
import { Course } from '../types';

export const fact_finding: Course = {
  id: "fact_finding",
  title: "Fact Finding Hearings",
  description: "Dealing with allegations. The Scott Schedule and Re H-N guidance.",
  icon: "🔍",
  totalModules: 12,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/fact_finding/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/fact_finding/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/fact_finding/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/fact_finding/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/fact_finding/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/fact_finding/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/fact_finding/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/fact_finding/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/fact_finding/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/fact_finding/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/fact_finding/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/fact_finding/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "What type of allegations typically trigger a fact-finding hearing in family court?",
        "o": [
            "Minor disagreements about school choices.",
            "Serious allegations involving domestic abuse, substance misuse, or harm.",
            "Disputes over holiday schedules.",
            "Financial disagreements without other serious allegations."
        ],
        "a": 1
    },
    {
        "q": "According to the slides, what is the standard of proof used by the court in a fact-finding hearing?",
        "o": [
            "Beyond a reasonable doubt (100% certainty).",
            "Clear and convincing evidence.",
            "Balance of Probabilities (51% likelihood).",
            "Preponderance of the evidence (any evidence counts)."
        ],
        "a": 2
    },
    {
        "q": "In modern family law, what does the court primarily look for when assessing allegations, according to the 'Paradigm Shift' guidance?",
        "o": [
            "Only isolated incidents.",
            "Patterns of behaviour and coercive control.",
            "Emotional narratives from parties.",
            "Arguments between barristers."
        ],
        "a": 1
    },
    {
        "q": "What is the name of the formal four-column table described as the primary tool for listing and responding to allegations?",
        "o": [
            "The Witness Statement.",
            "The Judicial Summary.",
            "The Scott Schedule.",
            "The Evidence Log."
        ],
        "a": 2
    },
    {
        "q": "Which of the following is NOT a recommended rule for surviving hostile cross-examination?",
        "o": [
            "Keep answers brief, using Yes/No where possible.",
            "Argue with the barrister to assert your position.",
            "Maintain absolute calm under pressure.",
            "Do not engage in arguments with the Judge."
        ],
        "a": 1
    }
]
};
